// extracted by mini-css-extract-plugin
export var caption = "style-module--caption--39d92";
export var iframeContainer = "style-module--iframeContainer--e7753";
export var instagram = "style-module--instagram--64524";
export var link = "style-module--link--2ed33";
export var other = "style-module--other--d3f64";
export var placeholder = "style-module--placeholder--dee9d";
export var vimeo = "style-module--vimeo--02c80";
export var youtube = "style-module--youtube--a9bdf";